import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const profGralSchema = () =>
  yup.object({
    iD_ProfGral: yup.number().label(i18n2._('#Perfil General')),
    description: yup
      .string()
      .label(i18n2._('Descripcion'))
      .required(i18n2._('Este campo es obligatorio')),
    profSpacs: yup
      .array()
      .label(i18n2._('ProfSpacs'))
      .required(i18n2._('Este campo es obligatorio')),
    revision: yup.number().label(i18n2._('Revision')),
    reason: yup
      .string()
      .max(255)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Motivo')),
    updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
    updatedBy: yup.string().label(i18n2._('Actualizado por')),
    deleted: yup.boolean().label(i18n2._('Eliminado')),
  });
